import { takeUntil } from "rxjs/operators";
import { HomeStreamEvent, HomeStreamService } from "../../services/home-ia/home-stream.service";
import { HomeDashboardStore } from "./home.component.dashboard-store";
import { HomeStreamEventCoordinator } from "./home-stream-event.coordinator";

export class HomeDashboardLifecycle {
  constructor(
    private readonly store: HomeDashboardStore,
    private readonly streamService: HomeStreamService,
    private readonly streamEvents: HomeStreamEventCoordinator
  ) {}

  initialize(onEvent?: (event: HomeStreamEvent) => void): void {
    localStorage.setItem("lastRoute", "/home");
    this.streamService.connect().pipe(takeUntil(this.store.destroy$))
      .subscribe((event) => onEvent ? onEvent(event) : this.streamEvents.handle(event));
  }
  destroy(): void {
    this.store.destroy$.next();
    this.store.destroy$.complete();
    this.streamEvents.dispose();
    this.streamService.disconnect();
  }
}
